class User {
  userIdentifier = '';
  roles = [];
}

export default User;
